import { render, staticRenderFns } from "./user-count-stat.vue?vue&type=template&id=2449b8ad&scoped=true&"
import script from "./user-count-stat.vue?vue&type=script&lang=js&"
export * from "./user-count-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2449b8ad",
  null
  
)

export default component.exports